/* Fabric Alex mobile PDP variant listener guard v1.
   The older corrective scripts still need their initial setup work, but their
   document-level variant callbacks compete with Warehouse's native gallery.
   Suppress only those registrations, only on touch/mobile, then restore the
   native document.addEventListener immediately after those scripts load. */
(function () {
  'use strict';

  if (!window.matchMedia('(max-width: 800px), (pointer: coarse)').matches) return;
  if (window.__faVariantGuardRestore) return;

  var originalAddEventListener = document.addEventListener;

  document.addEventListener = function (type, listener, options) {
    if (type === 'variant:changed') return;
    return originalAddEventListener.call(document, type, listener, options);
  };

  window.__faVariantGuardRestore = function () {
    document.addEventListener = originalAddEventListener;
    try {
      delete window.__faVariantGuardRestore;
    } catch (error) {
      window.__faVariantGuardRestore = null;
    }
  };
})();